__turbopack_context__.v({
  "start-button": "start-button-module-scss-module__ej3GpG__start-button",
  "start-button--banner": "start-button-module-scss-module__ej3GpG__start-button--banner",
  "start-button--disabled": "start-button-module-scss-module__ej3GpG__start-button--disabled",
});
